// Mensajes de baja confianza (auditoría del motor IA) para el usuario. Puro → testeable.
export const WB_LOW = 0.6;
export const EDIT_LOW = 0.6;

const pct = (v) => `${Math.round(v * 100)}%`;

export function confidenceNotes(audit) {
  if (!audit) return [];
  const notes = [];
  if (audit.zipWb === "plugin_only") {
    notes.push({ level: "info", text: "Balance de blancos: este RAW no guarda en el archivo su temperatura «Como se tomó» en formato legible; el ZIP lo deja «Como se tomó» y la corrección se aplica al sincronizar con el plugin." });
  }
  if (audit.aiSource === "motor") {
    notes.push({ level: "warn", text: `Básicos calculados por el motor local: el modelo IA no respondió${audit.aiError ? ` (${audit.aiError})` : ""}. Revisa la configuración de «Ajustes» en Proveedores IA y vuelve a procesar.` });
  } else if (audit.aiSource === "ia") {
    const c = Number(audit.aiConfidence);
    if (Number.isFinite(c) && c < EDIT_LOW) notes.push({ level: "warn", text: `El modelo IA editó con baja confianza (${pct(c)})${audit.aiNote ? `: ${audit.aiNote}` : ""}. Revisa esta foto en Lightroom.` });
    return notes; // el WB/exposición de la IA no usa las heurísticas del motor
  }
  const wbc = Number(audit.whiteBalanceConfidence);
  if (audit.wbSource === "none" || (!audit.wbApplied && !(wbc > 0))) {
    notes.push({ level: "info", text: "Balance de blancos: sin datos de color fiables; se mantiene «Como se tomó». Ajústalo en Lightroom si la luz lo requiere." });
  } else if (Number.isFinite(wbc) && wbc < WB_LOW) {
    const src = audit.wbSource === "grayworld" ? "estimado por gris medio, sin piel de referencia" : "con poca piel de referencia";
    const action = audit.wbApplied
      ? "Revisa Temperatura y Tinte en Lightroom antes de sincronizar el resto"
      : "No se corrigió; comprueba si la escena tiene dominante";
    const amb = audit.ambience === "tungsten" || audit.ambience === "golden_hour"
      ? " La luz cálida de ambiente se ha conservado a propósito." : "";
    notes.push({ level: "warn", text: `Balance de blancos con baja confianza (${pct(wbc)}, ${src}). ${action}.${amb}` });
  }
  const ec = Number(audit.editingConfidence);
  if (Number.isFinite(ec) && ec < EDIT_LOW) {
    notes.push({ level: "warn", text: `Edición con baja confianza (${pct(ec)}): escena difícil (luces y sombras recortadas). Revisa exposición, luces y sombras.` });
  }
  return notes;
}
